import { useSyncExternalStore } from 'react';
import { Download } from 'lucide-react';
import {
  subscribeInstall,
  canInstall,
  promptInstall,
  isStandalone,
  isIosSafari,
} from '@/lib/pwaInstall';
import styles from './InstallAppButton.module.css';

/**
 * "Install EVI Admin" affordance for the admin PWA. Mirrors the driver app's
 * InstallAppButton (same beforeinstallprompt handling + iOS Share-sheet hint),
 * branded EVI Admin and styled for the admin theme:
 *
 *   - Android / desktop Chromium: shows a button once the browser has offered an
 *     install prompt; clicking fires the native prompt.
 *   - iOS Safari: no prompt event exists, so shows the Add-to-Home-Screen hint.
 *   - Already installed (standalone) or no install path: renders nothing.
 *
 * Self-hides, so it's safe to drop into Settings as-is.
 */
export function InstallAppButton() {
  const installable = useSyncExternalStore(subscribeInstall, canInstall, () => false);

  // Already launched as an installed app — nothing to offer.
  if (isStandalone()) return null;

  if (installable) {
    return (
      <div className={styles.installWrap}>
        <p className={styles.installLabel}>Install EVI Admin</p>
        <p className={styles.installDesc}>
          Add EVI Admin to your phone&rsquo;s home screen for quick access.
        </p>
        <button
          type="button"
          className={styles.installButton}
          onClick={() => {
            void promptInstall();
          }}
        >
          <Download size={15} /> Install EVI Admin
        </button>
      </div>
    );
  }

  if (isIosSafari()) {
    return (
      <div className={styles.installWrap}>
        <p className={styles.installLabel}>Install EVI Admin</p>
        <p className={styles.iosHint}>
          To install: tap the Share icon, then <strong>Add to Home Screen</strong>.
        </p>
      </div>
    );
  }

  return null;
}
